<section data-step="3" class="step">
    <div class="newchapter">
        <h1 class="chapter">III.  <i class="mark pink">Rente</i></h1>
        <h2 class="chaptersubtitle">Want geld lenen kan geld kosten!</h2>
    </div>

    <div class="row">
        <div class="six columns">
            <p>
                Geld lenen kost geld. Logisch, want in de tijd dat jij iets leent van een ander, had die ander daar een hoop eigen dingen mee kunnen doen. Je betaalt dus eigenlijk een soort huur voor het mogen gebruiken van geld dat niet van jou is.
            </p>
            <p>
                Je betaalt rente elk jaar als een percentage over de schuld die je bij iemand hebt. Omdat je leent van de overheid, is dat percentage meestal lager dan de rente die je bij de bank zou moeten betalen. Bij de studiefinanciering is het percentage dat je betaalt aan rente gekoppeld aan wat de overheid _zelf_ betaalt aan rente op haar eigen schulden. Specifiek op staatsobligaties met een lengte van 5 jaar.
            </p>
        </div>
        <div class="six columns">
            {#if shown}
            <div use:chart={options} />
            {/if}
            <p>Terwijl je studeert wordt deze rente elk jaar berekend. Zodra je begint met de aflosfase wordt deze voor vijf jaar vastgesteld, en wordt vanaf dan elke vijf jaar opnieuw gekeken naar wat jij gaat betalen als rente op je studieschuld. Je betaalt daarna ook vijf jaar lang hetzelfde percentage aan rente.</p>
        </div>
    </div>

</section>

<script>
  import { chart } from "svelte-apexcharts";
  import { onMount } from "svelte";
  let options = {
    chart: {
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    series: [
      {
        name: "Rekenrente Studiefinanciering",
        data: [ 2.39,1.50,1.39,0.60,0.81,0.12,0.01,0.00,0.00,0.00,0.00,0.00,0.00],
      },
    ],
    xaxis: {
      categories: ['2010','2011','2012','2013','2014','2015','2016','2017','2018','2019','2020','2021','2022'],
      labels: {
        rotate: -45,
        rotateAlways: 1
      }
    },
    annotations: {
      position: 'front',
      texts: [{ 
          text: 'OverheidsObligaties 5 jaar', 
          textAnchor: 'middle',
          fontSize: '25px',
          foreColor: 'rgba(0,0,0,1)',
          fontFamily: 'Staatliches',
          x: '50%',
          y: '20px',
      }]
    }
    };
  let shown = false;
  onMount(() =>
    setTimeout(() => {
      shown = true;
    }, 500)
  );
</script>

